export const BILLING_TABS = {
  HISTORY: "history",
  INVOICES: "invoices",
  OVERVIEW: "overview",
  PAYMENT_METHODS: "payment-methods",
} as const;

export type BillingTabId = (typeof BILLING_TABS)[keyof typeof BILLING_TABS];

export const BILLING_TAB_CONFIG = [
  { id: BILLING_TABS.OVERVIEW, label: "Overview" },
  { id: BILLING_TABS.INVOICES, label: "Invoices" },
  { id: BILLING_TABS.PAYMENT_METHODS, label: "Payment methods" },
  { id: BILLING_TABS.HISTORY, label: "Subscription history" },
];

export function billingTabLabel(tabId: BillingTabId): string | undefined {
  return BILLING_TAB_CONFIG.find((t) => t.id === tabId)?.label;
}
